import React from 'react'
import { Badge } from '../index'
import * as colors from '../../assets/js/colors'

export default function CanhotoPrestacaoContasStatus({ status }) {
  // Render
  if (status === 'Pendente') {
    return <Badge color={colors.laranja}>Pendente</Badge>
  } else if (status === 'OK') {
    return <Badge color={colors.verde}>OK</Badge>
  } else if (status === 'Recusado') {
    return <Badge color={colors.vinho}>Recusado</Badge>
  } else {
    return <Badge color={colors.error}>Status Invalido</Badge>
  }
}
